// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/SellerForm/PointList/index.less
// module id = 1752
// module chunks = 0